export const AGTE_SECTIONS = {
    4: { name: 'Dil-Bilişsel', short: 'N.B', color: '#8bc34a', bg: '#dcedc8' },
    5: { name: 'İnce Motor', short: 'K.M', color: '#03a9f4', bg: '#b3e5fc' },
    6: { name: 'Kaba Motor', short: 'B.M', color: '#f44336', bg: '#ffcdd2' },
    7: { name: 'Sosyal Beceri', short: 'S.B', color: '#ffeb3b', bg: '#fff9c4' }
};

export const AGTE_MONTH_BOUNDARIES = [
    { label: '1-3 AY',   endIdx: 13,  totals: { 4: 4,  5: 2,  6: 3,  7: 4  } },
    { label: '4-5 AY',   endIdx: 27,  totals: { 4: 9,  5: 6,  6: 3,  7: 9  } },
    { label: '6-7 AY',   endIdx: 43,  totals: { 4: 13, 5: 11, 6: 7,  7: 12 } },
    { label: '8-9 AY',   endIdx: 49,  totals: { 4: 15, 5: 12, 6: 9,  7: 13 } },
    { label: '10-11 AY', endIdx: 59,  totals: { 4: 17, 5: 13, 6: 13, 7: 16 } },
    { label: '12-13 AY', endIdx: 70,  totals: { 4: 21, 5: 13, 6: 16, 7: 20 } },
    { label: '14-15 AY', endIdx: 76,  totals: { 4: 22, 5: 13, 6: 19, 7: 22 } },
    { label: '16-17 AY', endIdx: 84,  totals: { 4: 26, 5: 15, 6: 20, 7: 23 } },
    { label: '18-23 AY', endIdx: 101, totals: { 4: 33, 5: 17, 6: 22, 7: 29 } },
    { label: '24-29 AY', endIdx: 109, totals: { 4: 38, 5: 17, 6: 23, 7: 31 } },
    { label: '30-35 AY', endIdx: 120, totals: { 4: 46, 5: 18, 6: 23, 7: 33 } },
    { label: '36-47 AY', endIdx: 135, totals: { 4: 51, 5: 22, 6: 24, 7: 38 } },
    { label: '48-72 AY', endIdx: 154, totals: { 4: 65, 5: 26, 6: 24, 7: 39 } }
];

export const AGTE_CONVERSION = {
    4: [
        { score: 0,  age: 0  }, { score: 5,  age: 3  }, { score: 10, age: 5  }, { score: 13, age: 7  },
        { score: 15, age: 8  }, { score: 17, age: 11 }, { score: 20, age: 12 }, { score: 22, age: 13 },
        { score: 23, age: 13 }, { score: 24, age: 14 }, { score: 25, age: 15 }, { score: 26, age: 16 },
        { score: 27, age: 16 }, { score: 28, age: 18 }, { score: 29, age: 18 }, { score: 30, age: 19 },
        { score: 33, age: 21 }, { score: 35, age: 22 }, { score: 36, age: 23 }, { score: 37, age: 24 },
        { score: 38, age: 25 }, { score: 39, age: 26 }, { score: 40, age: 27 }, { score: 41, age: 28 },
        { score: 42, age: 29 }, { score: 43, age: 30 }, { score: 44, age: 31 }, { score: 45, age: 32 },
        { score: 46, age: 33 }, { score: 47, age: 34 }, { score: 48, age: 36 }, { score: 49, age: 39 },
        { score: 50, age: 41 }, { score: 51, age: 42 }, { score: 52, age: 44 }, { score: 53, age: 46 },
        { score: 54, age: 51 }, { score: 55, age: 54 }, { score: 58, age: 60 }, { score: 65, age: 72 }
    ],
    5: [
        { score: 0,  age: 0  }, { score: 2,  age: 2  }, { score: 3,  age: 3  }, { score: 5,  age: 4  },
        { score: 7,  age: 5  }, { score: 8,  age: 5  }, { score: 9,  age: 6  }, { score: 10, age: 6 },
        { score: 11, age: 7 }, { score: 12, age: 8 }, { score: 13, age: 10 }, { score: 14, age: 13 },
        { score: 15, age: 15 }, { score: 16, age: 18 }, { score: 17, age: 20 }, { score: 18, age: 24 },
        { score: 19, age: 29 }, { score: 20, age: 33 }, { score: 21, age: 39 }, { score: 22, age: 44 },
        { score: 23, age: 59 }, { score: 24, age: 67 }, { score: 26, age: 72 }
    ],
    6: [
        { score: 0,  age: 0  }, { score: 3,  age: 3  }, { score: 5,  age: 5  }, { score: 7,  age: 6  },
        { score: 8,  age: 7  }, { score: 9,  age: 8  }, { score: 10, age: 9  }, { score: 11, age: 10  },
        { score: 12, age: 11  }, { score: 13, age: 11 }, { score: 14, age: 12 }, { score: 15, age: 12 },
        { score: 16, age: 13 }, { score: 18, age: 14 }, { score: 19, age: 17 }, { score: 20, age: 18 },
        { score: 21, age: 21 }, { score: 22, age: 23 }, { score: 23, age: 35 }, { score: 24, age: 54 }
    ],
    7: [
        { score: 0,  age: 0  }, { score: 4,  age: 2  }, { score: 6,  age: 3  }, { score: 7,  age: 4  },
        { score: 8,  age: 5  }, { score: 10, age: 6  }, { score: 11, age: 6  }, { score: 12, age: 8  },
        { score: 13, age: 8 }, { score: 15, age: 9 }, { score: 16, age: 10 }, { score: 17, age: 11 },
        { score: 20, age: 12 }, { score: 22, age: 13 }, { score: 23, age: 14 }, { score: 25, age: 16 },
        { score: 26, age: 18 }, { score: 27, age: 19 }, { score: 28, age: 21 }, { score: 29, age: 23 },
        { score: 30, age: 24 }, { score: 31, age: 27 }, { score: 32, age: 29 }, { score: 33, age: 32 },
        { score: 34, age: 35 }, { score: 35, age: 41 }, { score: 36, age: 44 }, { score: 37, age: 54 },
        { score: 38, age: 60 }, { score: 39, age: 72 }
    ],
    'genel': [
        { score: 0,   age: 0  }, { score: 13,  age: 3  }, { score: 27,  age: 5  }, { score: 43,  age: 7  },
        { score: 49,  age: 9  }, { score: 59,  age: 11 }, { score: 70,  age: 13 }, { score: 76,  age: 14 },
        { score: 85,  age: 15 }, { score: 90,  age: 17 }, { score: 95,  age: 19 }, { score: 101, age: 21 },
        { score: 105, age: 23 }, { score: 110, age: 26 }, { score: 115, age: 29 }, { score: 120, age: 32 },
        { score: 125, age: 35 }, { score: 130, age: 41 }, { score: 135, age: 47 }, { score: 140, age: 54 },
        { score: 145, age: 67 }, { score: 154, age: 72 }
    ]
};

export const getDevelopmentalAge = (score, sectionId) => {
    const data = AGTE_CONVERSION[sectionId];
    if (!data) return 0;
    if (score >= data[data.length - 1].score) return data[data.length - 1].age;
    let age = 0;
    for (let i = 0; i < data.length; i++) {
        if (score >= data[i].score) {
            age = data[i].age;
        } else {
            break;
        }
    }
    return age;
};

export const calculateAGTEScores = (testData, answers) => {
    let totals = { 4: 0, 5: 0, 6: 0, 7: 0, general: 0 };
    let highestFullBlockIdx = -1;

    for (let i = 0; i < AGTE_MONTH_BOUNDARIES.length; i++) {
        const b = AGTE_MONTH_BOUNDARIES[i];
        const prevB = AGTE_MONTH_BOUNDARIES[i - 1];
        const sIdx = prevB ? prevB.endIdx + 1 : 1;
        const bQs = testData.questions.filter(q => q.question_order >= sIdx && q.question_order <= b.endIdx);
        const isFull = bQs.length > 0 && bQs.every(q => answers[q.id] === 1);
        if (isFull) highestFullBlockIdx = i;
    }

    if (highestFullBlockIdx !== -1) {
        const base = AGTE_MONTH_BOUNDARIES[highestFullBlockIdx].totals;
        totals = { ...base };
        const lastIdx = AGTE_MONTH_BOUNDARIES[highestFullBlockIdx].endIdx;
        testData.questions.forEach(q => {
            if (q.question_order > lastIdx && answers[q.id] === 1) totals[Number(q.section_id)] += 1;
        });
    } else {
        testData.questions.forEach(q => {
            if (answers[q.id] === 1) totals[Number(q.section_id)] += 1;
        });
    }
    totals.general = totals[4] + totals[5] + totals[6] + totals[7];
    return totals;
};

export const getStandardScore = (raw, section) => {
    if (raw === 0) return 0;
    if (section === 1) {
        if (raw >= 1 && raw <= 2) return 4;
        if (raw >= 3 && raw <= 5) return 5;
        if (raw >= 6 && raw <= 8) return 6;
        if (raw >= 9 && raw <= 11) return 7;
        if (raw >= 12 && raw <= 14) return 8;
        if (raw >= 15 && raw <= 17) return 9;
        if (raw >= 18 && raw <= 19) return 10;
        if (raw >= 20 && raw <= 22) return 11;
        if (raw >= 23 && raw <= 25) return 12;
        if (raw >= 26 && raw <= 28) return 13;
        if (raw >= 29 && raw <= 31) return 14;
        if (raw >= 32 && raw <= 34) return 15;
        if (raw >= 35 && raw <= 36) return 16;
        if (raw >= 37 && raw <= 39) return 17;
        if (raw >= 40 && raw <= 42) return 18;
        return 18;
    }
    if (section === 2) {
        if (raw === 1) return 4;
        if (raw >= 2 && raw <= 4) return 5;
        if (raw >= 5 && raw <= 7) return 6;
        if (raw >= 8 && raw <= 9) return 7;
        if (raw >= 10 && raw <= 12) return 8;
        if (raw >= 13 && raw <= 15) return 9;
        if (raw >= 16 && raw <= 18) return 10;
        if (raw >= 19 && raw <= 21) return 11;
        if (raw >= 22 && raw <= 24) return 12;
        if (raw >= 25 && raw <= 26) return 13;
        if (raw >= 27 && raw <= 29) return 14;
        if (raw >= 30 && raw <= 32) return 15;
        if (raw >= 33 && raw <= 35) return 16;
        if (raw >= 36 && raw <= 38) return 17;
        if (raw >= 39 && raw <= 41) return 18;
        if (raw === 42) return 19;
        return 19;
    }
    if (section === 3) {
        if (raw >= 1 && raw <= 3) return 4;
        if (raw >= 4 && raw <= 6) return 5;
        if (raw >= 7 && raw <= 9) return 6;
        if (raw >= 10 && raw <= 13) return 7;
        if (raw >= 14 && raw <= 16) return 8;
        if (raw >= 17 && raw <= 19) return 9;
        if (raw >= 20 && raw <= 22) return 10;
        if (raw >= 23 && raw <= 25) return 11;
        if (raw >= 26 && raw <= 29) return 12;
        if (raw >= 30 && raw <= 32) return 13;
        if (raw >= 33 && raw <= 35) return 14;
        if (raw >= 36 && raw <= 38) return 15;
        if (raw >= 39 && raw <= 41) return 16;
        if (raw === 42) return 17;
        return 17;
    }
    return 0;
};

export const getOBI = (sum, isThreeSection) => {
    const scores = isThreeSection ? {
        54: 153, 53: 151, 52: 149, 51: 146, 50: 144, 49: 142, 48: 140, 
        47: 138, 46: 136, 45: 133, 44: 131, 43: 129, 42: 127, 41: 125, 
        40: 123, 39: 120, 38: 118, 37: 116, 36: 114, 35: 112, 34: 110, 
        33: 107, 32: 105, 31: 103, 30: 101, 29: 99, 28: 97, 27: 94, 
        26: 92, 25: 90, 24: 88, 23: 86, 22: 83, 21: 81, 20: 79, 
        19: 77, 18: 75, 17: 73, 16: 70, 15: 68, 14: 66, 13: 64, 
        12: 62, 11: 60, 10: 57
    } : {
        35: 137, 34: 135, 33: 132, 32: 130, 31: 127, 30: 124, 29: 121, 
        28: 118, 27: 116, 26: 113, 25: 110, 24: 107, 23: 105, 22: 102, 
        21: 99, 20: 96, 19: 93, 18: 91, 17: 88, 16: 85, 15: 82, 
        14: 79, 13: 77, 12: 74, 11: 71, 10: 68, 9: 66, 8: 63, 
        7: 60, 6: 57
    };
    if (scores[sum]) return scores[sum];
    const keys = Object.keys(scores).map(Number).sort((a, b) => b - a);
    for (let key of keys) {
        if (sum >= key) return scores[key];
    }
    return 55;
};

export const getProbability = (index) => {
    if (index >= 100) return { text: "Görülmə ehtimalı olduqca yüksək", color: "#d32f2f", bg: "#fdecea" };
    if (index >= 90 && index < 100) return { text: "Görülmə ehtimalı Orta dərəcədə müşahidə edilir.", color: "#995050", bg: "#fdecea" };
    if (index >= 80 && index < 90) return { text: "Görülmə ehtimalı Yüngül dərəcədə müşahidə edilir.", color: "#ed7710", bg: "#fdecea" };
    if (index >= 70 && index < 80) return { text: "Görülmə ehtimalı var", color: "#f38e28", bg: "#fff4e5" };
    if (index < 70) return { text: "Müşahidə olunmur", color: "#13a70b", bg: "#fff4e5" };
    return { text: "Görülmə ehtimalı yox", color: "#388e3c", bg: "#edf7ed" };
};